import './AverageConsumption.scss';
import AverageConsumptionSegmented from './AverageConsumptionSegmented/AverageConsumptionSegmented';
import FuelPrice from './FuelPrice/FuelPrice';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
export default function AverageConsumption({ fields, tab, ITEMS, onChangeTab, onChange }) {
  return (
    <div className={'AverageConsumption'}>
      <div className={'card'} data-aos="fade-up">
        <h3 className={'card_title'}>
          <RichText field={fields?.fuelTypeAndPriceTitle} />
        </h3>
        <div className={'card_segmented'}>
          <AverageConsumptionSegmented
            items={ITEMS}
            activeIndex={tab.index}
            onClick={onChangeTab}
          />
        </div>
        <FuelPrice fields={fields} fuelPrice={tab?.fields?.value?.value} onChange={onChange} />
      </div>
    </div>
  );
}
